<dialog
  #scoreLastSessionDialog
  qai-dialog
  class="score-last-session-dialog"
  [class.results-mode]="state() === 'results'"
  [heading]="
    state() === 'notFound'
      ? ('simulationBuilder.SCORE_LAST_SESSION_MODAL_HEADING' | transloco)
      : state() === 'error'
        ? ('simulationBuilder.SCORE_LAST_SESSION_MODAL_ERROR_HEADING' | transloco)
        : simulationName()
  "
  [description]="
    state() === 'notFound'
      ? ('simulationBuilder.SCORE_LAST_SESSION_MODAL_DESCRIPTION' | transloco)
      : state() === 'error'
        ? ('simulationBuilder.SCORE_LAST_SESSION_MODAL_ERROR_DESCRIPTION' | transloco)
        : undefined
  "
  [showClose]="state() !== 'loading'"
  (closeButtonClicked)="handleClose()"
>
  @switch (state()) {
    @case ('loading') {
      <div class="state-message">
        <qai-loading size="medium" />
      </div>
    }
    @case ('notFound') {
      <div class="score-last-session-actions">
        <button qai-button kind="secondary" size="medium" (click)="handleClose()">
          {{ 'simulationBuilder.BUTTON_CANCEL' | transloco }}
        </button>
        <button
          qai-button
          kind="primary"
          size="medium"
          [disabled]="!replicaId() || isLaunchingTestSimulation()"
          (click)="handleTestSimulation()"
        >
          {{ 'simulationBuilder.TEST_SIMULATION_BUTTON' | transloco }}
        </button>
      </div>
    }
  }

  <ng-template #resultsPortalOutlet cdkPortalOutlet></ng-template>
</dialog>
